import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import { useDispatch } from 'react-redux';
import { fetchGameInfoAction } from "../../Core/myResultsActions";

const CloseBtn = ({game}) => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(fetchGameInfoAction({id: game.id}));
    };

    return (
        <FormattedMessage id="app.close">
            {message => (
                <Link
                    to={`/results/${game.id}`}
                    className="team-details___close"
                    title={message}
                    onClick={handleClick} // Add the click event handler
                >
                    <span className="team-details___close-label">
                        {message.toUpperCase()}
                        <span className="close-x">X</span>
                    </span>
                </Link>
            )}
        </FormattedMessage>
    );
};

export default CloseBtn;
